import md5 from 'md5';

const getMd5Hash = (data: string) => md5(`lD#$%${String(data)}%$#t41`);

export { getMd5Hash };
